import { useState } from 'react';
import { BillingApi } from '#shared/components/AccountAndBilling/types';

// The statement op is host-supplied — the (c) interface. The host normalizes its own response into
// { data, format }; this hook owns only the loading state and the Success check.
export default function useFetchStatement(fetchStatementOp: BillingApi['fetchStatement']) {
  const [fetching, setFetching] = useState(false);

  const fetchStatement: BillingApi['fetchStatement'] = async (params) => {
    try {
      setFetching(true);
      const res = await fetchStatementOp(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  };

  return { fetching, fetchStatement };
}
